import remoteEvent from '@tools/remoteEvent';

// 用于获取神策匿名ID
export const getAnonymousID = () => {
  let id = '';
  remoteEvent.emit(remoteEvent.evts.GET_SENSORS, (sensors) => {
    id = sensors.getAnonymousID();
  });
  return id;
};
